import { useMemo } from "react";

interface FormattedDateProps {
  date?: Date | string | number;
  monthNum?: number;
}

export default function useFormattedDate({ date, monthNum }: FormattedDateProps) {
  return useMemo(() => {
    const baseDate = date ? new Date(date) : new Date();
    const baseYear = baseDate.getFullYear();
    const baseMonthIndex = baseDate.getMonth();
    const baseDay = baseDate.getDate();
    let year = baseYear;
    let monthIndex = baseMonthIndex;

    if (typeof monthNum === "number" && monthNum !== 0) {
      const totalMonths = baseYear * 12 + baseMonthIndex + monthNum;
      year = Math.floor(totalMonths / 12);
      monthIndex = totalMonths % 12;

      if (monthIndex < 0) {
        monthIndex += 12;
        year -= 1;
      }
    }

    const daysInTargetMonth = new Date(year, monthIndex + 1, 0).getDate();
    const day = Math.min(baseDay, daysInTargetMonth);
    const formattedMonth = String(monthIndex + 1).padStart(2, "0");
    const formattedDay = String(day).padStart(2, "0");

    return `${year}-${formattedMonth}-${formattedDay}`;
  }, [date, monthNum])
}
